/** Single source of truth for the app version — update here on every release */
const APP_VERSION = "1.22.0";
export default APP_VERSION;
